export const alertInfoMap = {
  ALERT_INFO_CANCEL_BUTTON: 'CANCEL',
  DELETE_ALERT_INFO_CONFIRM_BUTTON: 'DELETE',
  MENU_ITEM_DELETE_ALERT_INFO_CONFIRM_BUTTON: 'YES, DELETE',
  DELETE_ALERT_INFO_CANCEL_BUTTON: 'CANCEL',
  ARCHIVE_ALERT_INFO_CONFIRM_BUTTON: 'ARCHIVE RECIPE',
  ARCHIVE_ALERT_INFO_CANCEL_BUTTON: 'CANCEL',
};

export const createGenericErrorMsg = (cause = '') => `The system encountered an error${cause ? ' ' + cause : ''}. Please try again.`
  + 'If you receive this message multiple times, please contact your system administrator';

export const genericErrorMsg = 'We have encountered a system error, Please contact customer service for further assistance'; 
